export const MIN_DURATION = 1; // night - otherwise you don't need a Hotel ^^